<template>
	<div>
		<ly-condition v-ref:conditions title="指定时间" ctitle="指定时间段"></ly-condition>
		<ly-search>
			<div slot="s1" class="mb10 tie-4 mr60">
				<label class="tie-f control-label tr c-grey pr20">负责BD</label>
				<div class="tie-s">
			    	<input type="text" class="form-control" placeholder="请输入负责BD姓名" v-model="formdata.bd">
				</div>
			</div>
			<div slot="s2" class="mb10 tie-4 mr60">
				<label class="tie-f control-label tr c-grey pr20">管理公司管理员</label>
				<div class="tie-s">
			    	<input type="text" class="form-control" placeholder="请输入管理员姓名" v-model="formdata.manager">
				</div>
			</div>
			<div slot="s3" class="mb10 tie-4 mr60">
				<label class="tie-f control-label tr c-grey pr20">管理公司名称</label>
				<div class="tie-s">
			    	<input type="text" class="form-control" placeholder="请输入管理公司名称" v-model="formdata.company_name">
				</div>
			</div>
			<div slot="s4" class="mb10 tie-4 mr60">
				<label class="tie-f control-label tr c-grey pr20">管理员电话</label>
				<div class="tie-s">
			    	<input type="text" class="form-control" placeholder="请输入管理员电话" v-model="formdata.manager_tel">
				</div>
			</div>
			<div slot="s5" class="mb10 tie-4 mr60">
				<label class="tie-f control-label tr c-grey pr20">管理公司负责人</label>
				<div class="tie-s">
			    	<input type="text" class="form-control" placeholder="请输入负责人姓名" v-model="formdata.charge_name">
				</div>
			</div>
			<div slot="s6" class="mb10 tie-4 mr60">
				<label class="tie-f control-label tr c-grey pr20">公司状态</label>
				<div class="tie-s">
			    	<select class="form-control" v-model="formdata.company_status">
			    		<option value="1">正常</option>
			    		<option value="0">停用</option>
			    		<option value="-1">过期</option>
			    	</select>
				</div>
			</div>
			<div slot="s66" class="mb10 tie-4 mr60">
				<label class="tie-f control-label tr c-grey pr20">到期时间筛选</label>
				<div class="tie-s">
			    	<select class="form-control" v-model="times">
			    		<option value="1">全部</option>
						<option value="2">10天内到期</option>
						<option value="3">30天内到期</option>
						<option value="4">60天内到期</option>
						<option value="5">90天内到期</option>
			    	</select>
				</div>
			</div>
		</ly-search>
		<ly-datalist title="管理公司列表" add="yes" addtxt="新建管理公司" url="company" infourl="company_add"
			:formdata="formdata" :datetime="datetime">
			<table class="table">
		        <thead>
		          <tr>
		            <th class="tc">管理公司名称</th>
		            <th class="tc">公司状态</th>
		            <th class="tc">管理公司编号</th>
		            <th class="tc">负责人</th>
		            <th class="tc">管理员</th>
		            <th class="tc">到期时间</th>
		            <th class="tc">管理员电话</th>
		            <th class="tc">旗下门店数</th>
		            <th class="tc">创建时间</th>
		            <th class="tc">负责BD</th>
		            <th class="tc">操作</th>
		          </tr>
		        </thead>
		        <tbody>
		        	<tr v-for="item in data">
			            <td class="tc">{{item.name}}</td>
			            <td class="tc">{{item.status | statusfilter}}</td>
			            <td class="tc">{{item.code}}</td>
			            <td class="tc">{{item.companyer}}</td>
			            <td class="tc">{{item.manage_admin}}</td>
			            <td class="tc">{{item.expiration_time}}</td>
			            <td class="tc">{{item.manage_phone}}</td>
			            <td class="tc">{{item.manage_shop_number}}</td>
			            <td class="tc">{{item.created_at}}</td>
			            <td class="tc">{{item.BD}}</td>
			            <td class="tc">
			            	<a v-link="{name:'company_info',params : {cid: item.id}}" class="button">查看</a>
			            	<a class="button" href="javascript:;" v-if="item.status==0" @click="enable(item.id)">启用</a>
			            	<a class="button" href="javascript:;" v-if="item.status==1" @click="disable(item.id)">停用</a>
			            	<a class="button" href="javascript:;" v-if="item.status=='-1'||item.status==1" @click="renewals(item)">续费</a>
			            </td>
			        </tr>
		        </tbody>
		    </table> 
		</ly-datalist>
		<!-- <ly-enable :information="ID" v-on:newEnable="newStatus" v-ref:enable></ly-enable> -->
		<!-- v-on:newDisable="newDisStatus" v-on:newRenewal="newRenStatus"  -->
		<ly-disable :ids="ID"  v-ref:disable></ly-disable>
		<ly-renewals :renew="ID"  v-ref:renewals></ly-renewals>
	</div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Com = require('../utils/Common.js');
	//条件的获取
	var getCondition = function(vm) {
		var data = vm.$refs.conditions.cond;	
		vm.datetime.date_start = data[0];
		vm.datetime.date_end = data[1];
	};
	//标准日期格式转换
	var getLocalTime = function(s){
		var curDate = new Date();
		var date_start = curDate.getFullYear() + '-' + (curDate.getMonth() + 1) + '-' + curDate.getDate();
		var tomDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
		var date_end = tomDate.getFullYear() + '-' + (tomDate.getMonth() + 1) + '-' + tomDate.getDate();
		return {
			date_start: date_start,
			date_end: date_end
		};
	};
	/**
	* 组件对象
	*/
	var Component = {
		data : function(){
			return {
				data : [],
				formdata: {
					bd : '', manager : '', company_name : '', manager_tel : '',charge_name : '',company_status:'1',expiration_time:''
				},
				times:'1',//
				//上传数据--时间
				datetime: {
					date_start: '',
					date_end: ''
				},
				//当前id/当前管理公司的信息
				ID: '',
			}
		},
		components :  {
			'ly-datalist' : require('../components/Datalist.vue'),
			'ly-condition' : require('../components/Condition.vue'),
			'ly-search' : require('../components/Search.vue'),
			/*'ly-enable' : require('../components/install/enable.vue'),*/
			'ly-disable' : require('../components/install/disable.vue'),
			'ly-renewals' : require('../components/install/Renewals.vue')
		},
		filters: {
			statusfilter:function(str){
				var out = '';
				switch(str){
					case 1:
						out = '正常';
						break;
					case 0:
						out = '停用';
						break;
					case -1:
						out = '过期';
						break;
				}
				return out;
			}
		},
		methods:{
			enable:function(id){
				/*this.ID = JSON.stringify(rs);
				this.$refs.enable.show();*/
				var self = this;
				Com.confirm('确认启用该门店？',function(){
					var data_ = {
						company_id:id,//管理公司id
						type:1,//1是开 0是停用
						stop_reason:'',//停用时传值
					};
					Http['statusChange'].create({
						key:[],
						data:data_,
						succ:function(rs){
							for(var i=0;i<self.data.length;i++){
								if(self.data[i].id ==id){
									//self.data[i].status = rs.now_status;
									self.data.splice(i,1);
								}
							}
						}
					})
				});
			},
			disable:function(rs){
				this.ID = rs;
				this.$refs.disable.show();
			},
			renewals:function(rs){
				//console.log(rs.name);
				this.ID = JSON.stringify(rs);
				this.$refs.renewals.show();
			},
			// newStatus:function(){
			// 	this.datalist();
			// }
			// newDisStatus:function(rs){
			// 	console.log("rs%O",rs);
			// 	for(var i=0;i<this.data.length;i++){
			// 		if(this.data[i].id == this.ID){
			// 			this.data[i].status = rs.now_status;
			// 		}
			// 	}
			// }
		},
		events : {
			datalist : function(data){
				this.data = data;
			},
			submit: function() {
				//调用上面的条件筛选方法
				getCondition(this);
				this.$broadcast('submit');
			},
			newDisable:function(rs){
				for(var i=0;i<this.data.length;i++){
					if(this.data[i].id == this.ID){
						//this.data[i].status = rs;
						this.data.splice(i,1);
					}
				}
			},
			newRenewal:function(rs){
				for(var i=0;i<this.data.length;i++){
					if(this.data[i].id == JSON.parse(this.ID).id){
						if(this.data[i].status == '-1'){//过期状态下续费
							//this.data[i].status = rs.status;
							if(rs.status == '-1'){
								this.data[i].expiration_time = rs.expiration_time;
							}else{
								this.data.splice(i,1);
							}
						}else{//正常状态下续费
							//this.data[i].status = rs.status;
							this.data[i].expiration_time = rs.expiration_time;
						}
					}
				}
			}
		},
		ready: function(){
			var self = this;
			this.$watch('times',function(){
				var nd = new Date();
				var newdata = '';
				if(self.times == '1'){
					self.formdata.expiration_time = '';
				}
				if(self.times == '2'){
					nd.setDate(nd.getDate()+10);
					var y = nd.getFullYear();  
					var m = nd.getMonth()+1;  
					var d = nd.getDate();  
					if(m <= 9) m = "0"+m;  
					if(d <= 9) d = "0"+d;   
					newdata = y+"-"+m+"-"+d;
					self.formdata.expiration_time = newdata;
				}
				if(self.times == '3'){
					nd.setDate(nd.getDate()+30);
					var y = nd.getFullYear();  
					var m = nd.getMonth()+1;  
					var d = nd.getDate();  
					if(m <= 9) m = "0"+m;  
					if(d <= 9) d = "0"+d;   
					newdata = y+"-"+m+"-"+d;
					self.formdata.expiration_time = newdata;
				}
				if(self.times == '4'){
					nd.setDate(nd.getDate()+60);
					var y = nd.getFullYear();  
					var m = nd.getMonth()+1;  
					var d = nd.getDate();  
					if(m <= 9) m = "0"+m;  
					if(d <= 9) d = "0"+d;   
					newdata = y+"-"+m+"-"+d;
					self.formdata.expiration_time = newdata;
				}
				if(self.times == '5'){
					nd.setDate(nd.getDate()+90);
					var y = nd.getFullYear();  
					var m = nd.getMonth()+1;  
					var d = nd.getDate();  
					if(m <= 9) m = "0"+m;  
					if(d <= 9) d = "0"+d;   
					newdata = y+"-"+m+"-"+d;
					self.formdata.expiration_time = newdata;
				}
			})

		}
	};
	module.exports = Component;
</script>


/** WEBPACK FOOTER **
 ** company_list.vue?10f82ac4
 **/